import { SingleEventPrediction } from "../SingleEventPrediction";
import { StagePointsTable } from "../../Scoring/StagePointsTables";
import { Athlete } from "../../../Shared/Athlete";
import { Wsm2023EventPredictionFinalistsSelectionStrategy } from "./Wsm2023EventPredictionFinalistsSelectionStrategy";
import { Wsm2026EventPredictionFinalistsSelectionStrategy } from "./Wsm2026EventPredictionFinalistsSelectionStrategy";
import { CompetitionRuleset } from "../../../../Enums/CompetitionRuleset";

export interface IEventPredictionFinalistsSelectionStrategy {
	GetFinalists(eventPredictions: Array<SingleEventPrediction>, pointsTable: StagePointsTable): Array<Athlete>;
}

export class EventPredictionFinalistsSelectionStrategyFactory {
	public static Create(ruleset: CompetitionRuleset): IEventPredictionFinalistsSelectionStrategy {
		switch (ruleset) {
			case CompetitionRuleset.Wsm2023: {
				return new Wsm2023EventPredictionFinalistsSelectionStrategy();
			}
			case CompetitionRuleset.Wsm2026: {
				return new Wsm2026EventPredictionFinalistsSelectionStrategy();
			}
			default: {
				throw new Error(`FinalistsSelectionStrategyFactory was not able to provide a strategy for ruleset: ${ruleset}`);
			}
		}
	}
}
